import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

const GreetingContainer = styled.div`
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
`;

const Greeting = () => {
  const [greeting, setGreeting] = useState("HELLO FRIEND");
  

  useEffect(() => {
    var currentTime = null;

    function checkTime() {
      var time = new Date().getHours();
      if (currentTime !== time) {
        currentTime = time;
        if (time >= 5 && time <= 12) {
          setGreeting("Good Morning"); 
        } else if (time >= 13 && time <= 17) {
          setGreeting("Good Afternoon");
        } else if (time >= 18 && time <= 23) {
          setGreeting("Good Evening");
        } else if (time >= 0 || time <= 4) {
          setGreeting("Good Night");
        }
      }
    }

    checkTime();
    setInterval(() => {
      checkTime();
    }, 60000);
  }, []);

  return (
    <GreetingContainer>
      <h1>{greeting}</h1>
    </GreetingContainer>
  );
};

export default Greeting;
